module.exports = __webpack_public_path__ + "img/two-lines-light.eeb2837c.svg";